import React from "react";
import Commons from "../../Services/Common/Common";
import TranslationService from "../../Services/Translation/TranslationService";
/** Styles Import */
import "sweetalert2/dist/sweetalert2.min.css";
import "./Style.css";
/** Components Import */
import Swal from "sweetalert2";

const defaultLanguage = { code: "KOR", name: "대한민국", flag: "https://flagcdn.com/kr.svg", lang: "ko" };
const language = Commons.Storages("get", "language") || defaultLanguage;

const swal = {
  custom: async (options = {}) => {
    // 버튼 텍스트 번역
    const confirmText = options.confirmButtonText || "확인";
    const cancelText = options.cancelButtonText || "취소";
    const denyText = options.denyButtonText || "거부";
    const closeText = options.closeButtonAriaLabel || "닫기";

    const translatedConfirmText = await TranslationService.translateText(confirmText, language.lang);
    const translatedCancelText = await TranslationService.translateText(cancelText, language.lang);
    const translatedDenyText = await TranslationService.translateText(denyText, language.lang);
    const translatedCloseText = await TranslationService.translateText(closeText, language.lang);

    return Swal.fire({
      // 기본 옵션
      title: (await TranslationService.translateText(options.title, language.lang)) || "", // 알림창의 제목
      text: (await TranslationService.translateText(options.text, language.lang)) || "", // 알림창의 내용 텍스트
      html: options.html || "", // HTML 형식의 내용 (text 대신 사용 가능)
      icon: options.icon || "", // 아이콘 타입 ('success', 'error', 'warning', 'info', 'question')

      // 버튼 관련 옵션
      showConfirmButton: options.showConfirmButton ?? true, // 확인 버튼 표시 여부
      showCancelButton: options.showCancelButton ?? false, // 취소 버튼 표시 여부
      showDenyButton: options.showDenyButton ?? false, // 거부 버튼 표시 여부
      confirmButtonText: translatedConfirmText, // 확인 버튼의 텍스트
      cancelButtonText: translatedCancelText, // 취소 버튼의 텍스트
      denyButtonText: translatedDenyText, // 거부 버튼의 텍스트
      confirmButtonColor: options.confirmButtonColor || "#3085d6", // 확인 버튼의 색상
      cancelButtonColor: options.cancelButtonColor || "#aaa", // 취소 버튼의 색상
      denyButtonColor: options.denyButtonColor || "#dc3545", // 거부 버튼의 색상
      buttonsStyling: options.buttonsStyling ?? true, // 버튼에 기본 스타일 적용 여부
      reverseButtons: options.reverseButtons ?? false, // 버튼 순서 반전 (확인-취소 → 취소-확인)

      // 포커스 관련 옵션
      focusConfirm: options.focusConfirm ?? true, // 알림창이 열릴 때 확인 버튼에 포커스
      focusCancel: options.focusCancel ?? false, // 알림창이 열릴 때 취소 버튼에 포커스
      focusDeny: options.focusDeny ?? false, // 알림창이 열릴 때 거부 버튼에 포커스

      // 닫기 관련 옵션
      showCloseButton: options.showCloseButton ?? false, // 우측 상단 닫기 버튼 표시 여부
      closeButtonHtml: options.closeButtonHtml || "&times;", // 닫기 버튼의 HTML
      closeButtonAriaLabel: translatedCloseText, // 닫기 버튼의 접근성 레이블

      // 타이머 관련 옵션
      timer: options.timer, // 자동으로 닫히는 시간 (밀리초)
      timerProgressBar: options.timerProgressBar ?? false, // 타이머 진행바 표시 여부

      // 위치 관련 옵션
      position: options.position || "center", // 알림창의 위치 ('top', 'top-start', 'top-end', 'center', 'center-start', 'center-end', 'bottom', 'bottom-start', 'bottom-end')

      // 크기 관련 옵션
      width: options.width, // 알림창의 너비
      padding: options.padding, // 알림창의 내부 여백
      background: options.background, // 알림창의 배경색

      // 애니메이션 관련 옵션
      grow: options.grow || false, // 알림창의 확장 방향 ('row', 'column', 'fullscreen', false)
      backdrop: options.backdrop ?? true, // 배경 오버레이 표시 여부
      allowOutsideClick: options.allowOutsideClick ?? false, // 외부 클릭으로 닫기 허용 여부 (기본값: false)
      allowEscapeKey: options.allowEscapeKey ?? false, // ESC 키로 닫기 허용 여부 (기본값: false)
      allowEnterKey: options.allowEnterKey ?? true, // Enter 키로 확인 허용 여부
      stopKeydownPropagation: options.stopKeydownPropagation ?? true, // 키보드 이벤트 전파 중단 여부
      zIndex: options.zIndex ?? 40000, // 다른 모달 위로 오도록 z-index 상향

      // 커스텀 클래스 옵션
      customClass: options.customClass || {
        container: "...",
        popup: "...",
        header: "...",
        title: "...",
        closeButton: "...",
        icon: "...",
        image: "...",
        htmlContainer: "...",
        input: "...",
        inputLabel: "...",
        validationMessage: "...",
        actions: "...",
        confirmButton: "...",
        denyButton: "...",
        cancelButton: "...",
        loader: "...",
        footer: "....",
        timerProgressBar: "....",
      }, // 커스텀 CSS 클래스 설정

      // 이미지 관련 옵션
      imageUrl: options.imageUrl, // 이미지 URL
      imageWidth: options.imageWidth, // 이미지 너비
      imageHeight: options.imageHeight, // 이미지 높이
      imageAlt: options.imageAlt || "", // 이미지 대체 텍스트

      // 입력 필드 관련 옵션
      input: options.input, // 입력 필드 타입 ('text', 'email', 'password', 'number', 'tel', 'range', 'textarea', 'select', 'radio', 'checkbox', 'file', 'url')
      inputPlaceholder: options.inputPlaceholder || "", // 입력 필드의 placeholder
      inputValue: options.inputValue || "", // 입력 필드의 기본값
      inputOptions: options.inputOptions || {}, // select, radio, checkbox 타입의 옵션
      inputAutoTrim: options.inputAutoTrim ?? true, // 입력값 자동 trim 여부
      inputAttributes: options.inputAttributes || {}, // 입력 필드의 추가 속성
      inputValidator: options.inputValidator, // 입력값 검증 함수

      // 검증 관련 옵션
      validationMessage: options.validationMessage, // 검증 실패 시 표시할 메시지

      // 진행 단계 관련 옵션
      progressSteps: options.progressSteps || [], // 진행 단계 배열
      currentProgressStep: options.currentProgressStep, // 현재 진행 단계
      progressStepsDistance: options.progressStepsDistance || "40px", // 진행 단계 간의 간격

      // 콜백 함수 옵션
      willOpen: options.willOpen || (() => {}), // 알림창이 열리기 전에 실행되는 함수
      willClose: options.willClose || (() => {}), // 알림창이 닫히기 전에 실행되는 함수

      // 스크롤 관련 옵션
      scrollbarPadding: options.scrollbarPadding ?? true, // 스크롤바 여백 적용 여부
    });
  },
  success: async (title = "", text = "") => {
    const translatedConfirmText = await TranslationService.translateText("확인", language.lang);
    return Swal.fire({
      title: await TranslationService.translateText(title, language.lang),
      text: await TranslationService.translateText(text, language.lang),
      icon: "success",
      confirmButtonText: translatedConfirmText,
    });
  },
  error: async (title = "", text = "") => {
    const translatedConfirmText = await TranslationService.translateText("확인", language.lang);
    return Swal.fire({
      title: await TranslationService.translateText(title, language.lang),
      text: await TranslationService.translateText(text, language.lang),
      icon: "error",
      confirmButtonText: translatedConfirmText,
    });
  },
  warning: async (title = "", text = "") => {
    const translatedConfirmText = await TranslationService.translateText("확인", language.lang);
    return Swal.fire({
      title: await TranslationService.translateText(title, language.lang),
      text: await TranslationService.translateText(text, language.lang),
      icon: "warning",
      confirmButtonText: translatedConfirmText,
    });
  },
  info: async (title = "", text = "") => {
    const translatedConfirmText = await TranslationService.translateText("확인", language.lang);
    return Swal.fire({
      title: await TranslationService.translateText(title, language.lang),
      text: await TranslationService.translateText(text, language.lang),
      icon: "info",
      confirmButtonText: translatedConfirmText,
    });
  },
  question: async (title = "", text = "") => {
    const translatedConfirmText = await TranslationService.translateText("확인", language.lang);
    return Swal.fire({
      title: await TranslationService.translateText(title, language.lang),
      text: await TranslationService.translateText(text, language.lang),
      icon: "question",
      confirmButtonText: translatedConfirmText,
    });
  },
  confirm: async (title = "", text = "") => {
    const translatedConfirmText = await TranslationService.translateText("확인", language.lang);
    const translatedCancelText = await TranslationService.translateText("취소", language.lang);
    return Swal.fire({
      title: await TranslationService.translateText(title, language.lang),
      text: await TranslationService.translateText(text, language.lang),
      showCancelButton: true,
      confirmButtonText: translatedConfirmText,
      cancelButtonText: translatedCancelText,
    });
  },
  loading: async (isLoading = false, title = "Loading...", text = "") => {
    if (isLoading) {
      return Swal.fire({
        title: await TranslationService.translateText(title, language.lang),
        html: await TranslationService.translateText(text, language.lang),
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  },
  close: () => {
    return Swal.close();
  },
};

export default swal;
